export default () => ({
	login_form: document.getElementById('customer-login-form'),
	recover_form: document.getElementById('recover-form'),
	forgot: false,
	success: false,
	email: '',
	email_error: false,
	recover_email: '',
	recover_email_error: false,
	password: document.getElementById('password'),
	password_error: false,

	showForgot() {
		this.forgot = true;
	},

	async submit() {
		this.checkRecoverValidity();
		if (!this.recover_email_error) {
			const data = new URLSearchParams(new FormData(this.recover_form)).toString();
			const responce = await fetch(this.recover_form.action, {
				method: 'POST',
				body: data,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
					Accept: 'text/html, */*; q=0.01',
					'X-Requested-With': 'XMLHttpRequest',
				},
			});

			const result = await responce.text();
			const parser = new DOMParser().parseFromString(result, 'text/html');
			const error_message = parser.getElementById('recover-form-error');
			const success_message = parser.getElementById('recover-form-success');

			if (error_message) {
				this.$refs.error.innerText = error_message.innerText;
			}

			if (success_message) {
				this.$refs.success.innerText = success_message.innerText;
				this.success = true;
			}
		}
	},

	async login(form) {
		this.checkLoginValidity();
		if (!this.email_error && !this.password_error) {
			const data = new URLSearchParams(new FormData(form)).toString();
			const responce = await fetch(form.action, {
				method: 'POST',
				body: data,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
					Accept: 'text/html, */*; q=0.01',
					'X-Requested-With': 'XMLHttpRequest',
				},
			});

			const result = await responce.text();
			const parser = new DOMParser().parseFromString(result, 'text/html');
			const error_message = parser.getElementById('customer-login-errors');

			if (error_message) {
				this.$refs.loginError.innerHTML = error_message.innerHTML;
			} else {
				location.reload();
			}
		}
	},

	checkLoginValidity() {
		const regex =
			/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

		if (this.email.toLocaleLowerCase().match(regex)) {
			this.email_error = false;
		} else {
			this.email_error = true;
		}

		if (this.password.value === '' || this.password.value.length <= 5) {
			this.password_error = true;
		} else {
			this.password_error = false;
		}

		setTimeout(() => {
			const error_fields = [...this.login_form.querySelectorAll('.account-popup__input.error')];
			if (error_fields.length > 0) {
				error_fields[0].focus();
			}
		}, 50);
	},

	checkRecoverValidity() {
		const regex =
			/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

		if (this.recover_email.toLocaleLowerCase().match(regex)) {
			this.recover_email_error = false;
		} else {
			this.recover_email_error = true;
		}

		setTimeout(() => {
			const error_field = this.recover_form.querySelector('.account-popup__input.error');
			if (error_field.length > 0) {
				error_field.focus();
			}
		}, 50);
	},

	initClose() {
		setTimeout(() => {
			this.forgot = false;
			this.success = false;
			this.email_error = false;
			this.recover_email_error = false;
			this.password_error = false;
		}, 350);
	},

	togglePassword() {
		const type = this.password.getAttribute('type') === 'password' ? 'text' : 'password';
		this.password.setAttribute('type', type);
	},

	init() {
		this.login_form.addEventListener('submit', (event) => {
			event.preventDefault();
			this.login(this.login_form);
		});
	},
});
